module.exports = __webpack_public_path__ + "static/media/arrow_down.99410820.svg";